<template>
  <div>
    <v-dialog v-model="show" max-width="406" flat elevation="0" persistent>
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5 px-5">
        <v-card-title>
          <div
            class="defaultColor--text font-weight-regular text-center px-12"
            style="font-size: 15px; line-height: 25px"
          >
            {{ $t("description.liveStreamStartDescription") }}
          </div>
        </v-card-title>

        <v-card-actions class="justify-center align-center pb-5 mt-0">
          <v-btn
            color="greenColor"
            class="white--text text-capitalize rounded-pill"
            block
            height="67"
            elevation="0"
            rounded
            large
            @click="gotoLiveStreamPage()"
          >
            {{ $t("buttons.startStream") }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="closeModal" />
    </v-dialog>
  </div>
</template>

<script>
import DialogCloseButton from "../General/DialogCloseButton.vue";

export default {
  data() {
    return {};
  },
  props: {
    visible: Boolean,
  },
  mounted() {},
  components: {
    DialogCloseButton,
  },
  methods: {
    gotoLiveStreamPage(){
        this.closeModal();
        this.$store.state.liveStreamDialogStatus = true
    },
    
    closeModal() {
      this.$store.state.liveStreamStartInfoDialogShow = false;
      this.show = false;
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {},
};
</script>
